import { createRoot } from 'react-dom/client';
import { Theme } from '@classify/react-core-components/Theme';
import RootMeButton from '../components/RootMeV2Button';
function isRootMeUrl(url: URL) {
  return url.hostname === 'root-me.pro' && url.searchParams.has('groupId');
}
export default function handleRootmeLinks(domContainer: HTMLElement) {
  const links = Array.from(domContainer.getElementsByTagName('a'));
  const {
    dataset: {
      currentUserEmail,
      translations,
      tokenRootme
    }
  } = domContainer as any;
  if (!links.length || !currentUserEmail) return null;
  return links.map(linkElement => [new URL(linkElement.href), linkElement] as [URL, HTMLAnchorElement]).filter(([url]) => isRootMeUrl(url)).forEach(([url, linkElement], n) => {
    const groupId = url.searchParams.get('groupId');
    if (!groupId) return;
    const rootContainer = document.createElement('span');
    rootContainer.style.display = 'block';
    rootContainer.style.textAlign = 'center';
    rootContainer.style.padding = '8px 0';
    linkElement.parentNode?.replaceChild(rootContainer, linkElement);
    const root = createRoot(rootContainer);
    root.render(<Theme productionPrefix={`rootme_${n}`}>
          <RootMeButton currentUserEmail={currentUserEmail} groupId={groupId} originalUrl={url.toString()} publicToken={tokenRootme || ''} translations={JSON.parse(translations || '{}')}>
            {linkElement.innerHTML}
          </RootMeButton>
        </Theme>);
  });
}